import { Injectable } from '@angular/core';
import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from '@angular/forms';
import * as moment from 'moment';

@Injectable()
export class ValidateService {

  constructor() {
  }

  validateEmptyString(control: AbstractControl) {
    if (!control.value) {
      return null;
    }
    const value = control.value;
    return value.trim() ? null : { 'emptyString': true };
  }

  validateInteger(control: AbstractControl) {
    if (!control.value) {
      return null;
    }
    const value = control.value;
    if (value.toString().indexOf('.') >= 0) {
      return { 'NotInteger': true };
    }
  }

  validatePressure(control: AbstractControl) {
    if (!control.value) {
      return null;
    }
    const r = /^\\d+$/;
    const flag = r.test(control.value);
    if (!flag) {
      return { pressure: true };
    }
  }

  validateTel(control: AbstractControl) {
    if (!control.value) {
      return null;
    }
    const r = /^1[3456789]\d{9}$/;
    const flag = r.test(control.value);
    if (!flag) {
      return { tel: true };
    }
  }

  validateMail(control: AbstractControl) {
    if (!control.value) {
      return null;
    }
    const r = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
    const flag = r.test(control.value);
    if (!flag) {
      return { mail: true };
    }
  }

  /**验证报警代码格式*/
  validateAlarmCodeFormat(control: AbstractControl) {
    if (!control.value) {
      return null;
    }
    const regExp = /^[A-Za-z]\w*$/;
    const flag = regExp.test(control.value);
    if (!flag) {
      return { 'invalidAlarmCodeFormat': true };
    }
    return null;
  }

  /**验证设备参数点格式*/
  validateParameterNameFormat(control: AbstractControl) {
    if (!control.value) {
      return null;
    }
    const regExp = /^[A-Za-z]\w*$/;
    const flag = regExp.test(control.value);
    if (!flag) {
      return { 'invalidParameterNameFormat': true };
    }
    return null;
  }

  /**验证格式:以字母开头，可包含字母、数字和下划线，最大长度 30*/
  validateNameFormat(control: AbstractControl) {
    if (!control.value) {
      return null;
    }
    const regExp = /^[A-Za-z]\w{0,29}$/;
    const flag = regExp.test(control.value);
    if (!flag) {
      return { 'invalidFormat': true };
    }
    return null;
  }

  /**验证格式:大于0的整数*/
  validatePositiveIntegerFormat(control: AbstractControl) {
    if (!control.value && control.value !== 0) {
      return null;
    }
    const regExp = /[1-9]\d*$/;
    const flag = regExp.test(control.value);
    if (!flag) {
      return { 'invalidFormat': true };
    }

    return null;
  }

  /**验证格式:1到600的整数*/
  validateIntegerRange(control: AbstractControl) {
    if (!control.value) {
      return null;
    }
    const regExp = /^(600|[1-5][0-9][0-9]|[1-9][0-9]|[1-9])$/;
    const flag = regExp.test(control.value);
    if (!flag) {
      return { 'invalidIntegerRange': true };
    }
    return null;
  }

  /**验证格式:经度0-180°*/
  validateLongitudeFormat(control: AbstractControl) {
    if (!control.value) {
      return null;
    }
    // const regExp = /^(([0-9]|[1-9][0-9]|1[0-7][0-9])(\.[0-9]+)?|180)$/;
    // const flag = regExp.test(control.value);
    // if (!flag) {
    //   return { 'invalidFormat': true };
    // }
    if (control.value < -180 || control.value > 180) {
      return { 'invalidFormat': true };
    }
    return null;
  }

  /**验证格式:纬度0-90°*/
  validateLatitudeFormat(control: AbstractControl) {
    if (!control.value) {
      return null;
    }
    // const regExp = /^(([0-9]|[1-8][0-9]|90)(\.[0-9]+)?|90)$/;
    // const flag = regExp.test(control.value);
    // if (!flag) {
    //   return { 'invalidFormat': true };
    // }
    if (control.value < -90 || control.value > 90) {
      return { 'invalidFormat': true };
    }
    return null;
  }

  /**验证格式:邮箱**/
  validateEmailFormat(control: AbstractControl) {
    if (!control.value) {
      return null;
    }
    const regExp = /[\w!#$%&'*+/=?^_`{|}~-]+(?:\.[\w!#$%&'*+/=?^_`{|}~-]+)*@(?:[\w](?:[\w-]*[\w])?\.)+[\w](?:[\w-]*[\w])?/;
    const flag = regExp.test(control.value);
    if (!flag) {
      return { 'invalidFormat': true };
    }
    return null;
  }

  /**参数上下限验证*/
  upperLowerValidator: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
    control.get('lower').setErrors(null);
    control.get('lowerMessage').setErrors(null);
    control.get('lowerLevel').setErrors(null);
    control.get('lowerLower').setErrors(null);
    control.get('lowerLowerMessage').setErrors(null);
    control.get('lowerLowerLevel').setErrors(null);
    control.get('upper').setErrors(null);
    control.get('upperMessage').setErrors(null);
    control.get('upperLevel').setErrors(null);
    control.get('upperUpper').setErrors(null);
    control.get('upperUpperMessage').setErrors(null);
    control.get('upperUpperLevel').setErrors(null);

    const lower = control.get('lower').value;
    const lowerLevel = control.get('lowerLevel').value;
    const lowerMessage = control.get('lowerMessage').value;
    let formValid = true;
    if (!(this.isNullOrEmpty(lower) && this.isNullOrEmpty(lowerMessage) && !lowerLevel)) {
      if (this.isNullOrEmpty(lower)) {
        control.get('lower').setErrors({ 'required': true });
        formValid = false;
      }
      if (this.isNullOrEmpty(lowerMessage)) {
        control.get('lowerMessage').setErrors({ 'required': true });
        formValid = false;
      }
      if (!lowerLevel) {
        control.get('lowerLevel').setErrors({ 'required': true });
        formValid = false;
      }
    }

    const lowerLower = control.get('lowerLower').value;
    const lowerLowerLevel = control.get('lowerLowerLevel').value;
    const lowerLowerMessage = control.get('lowerLowerMessage').value;
    if (!(this.isNullOrEmpty(lowerLower) && this.isNullOrEmpty(lowerLowerMessage) && !lowerLowerLevel)) {
      if (this.isNullOrEmpty(lowerLower)) {
        control.get('lowerLower').setErrors({ 'required': true });
        formValid = false;
      }
      if (this.isNullOrEmpty(lowerLowerMessage)) {
        control.get('lowerLowerMessage').setErrors({ 'required': true });
        formValid = false;
      }
      if (!lowerLowerLevel) {
        control.get('lowerLowerLevel').setErrors({ 'required': true });
        formValid = false;
      }
    }

    const upperUpper = control.get('upperUpper').value;
    const upperUpperLevel = control.get('upperUpperLevel').value;
    const upperUpperMessage = control.get('upperUpperMessage').value;
    if (!(this.isNullOrEmpty(upperUpper) && this.isNullOrEmpty(upperUpperMessage) && !upperUpperLevel)) {
      if (this.isNullOrEmpty(upperUpper)) {
        control.get('upperUpper').setErrors({ 'required': true });
        formValid = false;
      }
      if (this.isNullOrEmpty(upperUpperMessage)) {
        control.get('upperUpperMessage').setErrors({ 'required': true });
        formValid = false;
      }
      if (!upperUpperLevel) {
        control.get('upperUpperLevel').setErrors({ 'required': true });
        formValid = false;
      }
      
    }

    const upper = control.get('upper').value;
    const upperLevel = control.get('upperLevel').value;
    const upperMessage = control.get('upperMessage').value;
    if (!(this.isNullOrEmpty(upper) && this.isNullOrEmpty(upperMessage) && !upperLevel)) {
      if (this.isNullOrEmpty(upper)) {
        control.get('upper').setErrors({ 'required': true });
        formValid = false;
      }
      if (this.isNullOrEmpty(upperMessage)) {
        control.get('upperMessage').setErrors({ 'required': true });
        formValid = false;
      }
      if (!upperLevel) {
        control.get('upperLevel').setErrors({ 'required': true });
        formValid = false;
      }
    }
    //上限  上上限 比较值
    if (!this.isNullOrEmpty(upper) && !this.isNullOrEmpty(upperUpper) && upper >= upperUpper) {
      control.get('upper').setErrors({ 'upperMustLessThanUpperUpper': true });
      formValid = false;
    }
    //下限  下下限 比较值
    if (!this.isNullOrEmpty(lower) && !this.isNullOrEmpty(lowerLower) && lower <= lowerLower) {
      control.get('lowerLower').setErrors({ 'lowerLowerMustLessThanLower': true });
      formValid = false;
    }
    //上限 下限 比较值
    if (!this.isNullOrEmpty(lower) && !this.isNullOrEmpty(upper) && lower >= upper) {
      control.get('lower').setErrors({ 'lowerMustLessThanUpper': true });
      formValid = false;
    }

    //上上限 下限 比较值
    if (!this.isNullOrEmpty(upperUpper) && !this.isNullOrEmpty(lower) && upperUpper <= lower) {
      control.get('lower').setErrors({ 'lowerMustLessThanUpperUpper': true });
      formValid = false;
    }


    //上限  下下限 比较值
    if (!this.isNullOrEmpty(upper) && !this.isNullOrEmpty(lowerLower) && upper <= lowerLower) {
      control.get('lowerLower').setErrors({ 'lowerLowerMustLessThanUpper': true });
      formValid = false;
    }


    //上上限 下下限 比较值
    if (!this.isNullOrEmpty(upperUpper) && !this.isNullOrEmpty(lowerLower) && upperUpper <= lowerLower) {
      control.get('lowerLower').setErrors({ 'lowerLowerMustLessThanUpperUpper': true });
      formValid = false;
    }

    if (formValid) return null;
    return { 'upperLowerError': true };
  };

  /**判断值是否为空*/
  public isNullOrEmpty = (value: any): boolean => {
    return value === null || value === '' || value === undefined;
  }

  /**开始结束时间验证*/
  beginEndTimeValidator: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
    control.get('beginTime').setErrors(null);
    control.get('endTime').setErrors(null);
    const beginTime = control.get('beginTime').value;
    const endTime = control.get('endTime').value;
    let formValid = true;
    if (!this.isNullOrEmpty(beginTime) && !this.isNullOrEmpty(endTime) && moment(beginTime).format('YYYYMMDD') > moment(endTime).format('YYYYMMDD')) {
      control.get('endTime').setErrors({ 'endTimeMustBiggerThanStartTime': true });
      formValid = false;
    }
    if (formValid) return null;
    return { 'beginEndTimeError': true };
  }

  /**开始结束时间验证-------历史数据查询*/
  beginEndDateValidator: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
    control.get('start').setErrors(null);
    control.get('end').setErrors(null);
    const start = control.get('start').value;
    const end = control.get('end').value;
    let formValid = true;
    if (!this.isNullOrEmpty(start) && !this.isNullOrEmpty(end) && start > end) {
      control.get('end').setErrors({ 'endTimeMustBiggerThanStartTime': true });
      formValid = false;
    };
    if (this.isNullOrEmpty(start)) {
      control.get('start').setErrors({ 'required': true });
      formValid = false;
    }
    if (this.isNullOrEmpty(end)) {
      control.get('end').setErrors({ 'required': true });
      formValid = false;
    }
    if (formValid) return null;
  }


  /*时间区间不能超过30天*/
  timeRangeValidator: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
    // control.get('timeRange1').setErrors(null);
    // control.get('timeRange2').setErrors(null);
    const timeRange1 = control.get('timeRange1').value;
    const timeRange2 = control.get('timeRange2').value;
    let formValid = true;
    if (timeRange1) {
      const range1 = timeRange1 as Array<Date>;
      const day = moment(range1[1]).diff(moment(range1[0]), 'day');
      if (day > 30) {
        formValid = false;
        control.get('timeRange1').setErrors({ 'exceedRange': true });
      }
    }
    if (timeRange2) {
      const range2 = timeRange2 as Array<Date>;
      const day = moment(range2[1]).diff(moment(range2[0]), 'day');
      if (day > 31) {
        formValid = false;
        control.get('timeRange2').setErrors({ 'exceedRange': true });
      }
    }
    if (formValid) return null;
  }

  /*时间区间不能超过30天*/
  timeRangeValidator2: ValidatorFn = (control: FormGroup): ValidationErrors | null => {
    const timeRange = control.get('timeRange').value;
    let formValid = true;
    if (timeRange) {
      const range = timeRange as Array<Date>;
      const day = moment(range[1]).diff(moment(range[0]), 'day');
      if (day > 30) {
        formValid = false;
        control.get('timeRange').setErrors({ 'exceedRange': true });
      }
    }
    if (formValid) return null;
  }

  /*新增参数时设备参数无法重复绑定*/
  deviceParamValidator(control: FormGroup, paramsList: Array<any>): ValidationErrors | null {
    const currentDeviceParam = control.get('deviceParameter').value;
    if (!control.value) {
      return null;
    }
    const value = control.value;
    const deviceParam = paramsList.find(item => item.parameterId === currentDeviceParam);
    if(deviceParam){
      control.get('deviceParameter').setErrors({'parameterHasBound': true});
    }
  }

}



